import { makeStyles, shorthands } from '@fluentui/react-components';

export const useDrawerContainerStyles = makeStyles({
  divider: {
    flexGrow: 0,
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    width: '-webkit-fill-available',
  },
  searchbox: {
    flexGrow: 1,
  },
  tree: {
    maxHeight: 'none',
    height: '-webkit-fill-available',
  },
  footer: {
    alignSelf: 'stretch',
  },
  spinner: {
    marginTop: '50px',
  },
  hiddenA11yAnnounceArea: {
    position: 'absolute',
    width: '1px',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    ...shorthands.margin(0),
    ...shorthands.overflow('hidden'),
    ...shorthands.padding(0),
    ...shorthands.border('0'),
  },
});
